module.exports = __webpack_public_path__ + "h5/img/ren3.a865e331.png";